import React, { useState, useEffect } from 'react';
import PopupTiempo from './PopupTiempo.js';
import ComboSelectorParticipante from '../UI/campos/ComboSelectorParticipante.js';
import * as TipoObjeto from '../constantes/TipoObjeto.js';
import * as Titularidad from '../constantes/Titularidad.js';
import { encontrarCodigoString } from '../funciones/FuncionesArray.js';
import * as Funciones from '../funciones/FuncionesFormacion.js';
import * as FuncionesPersona from '../funciones/FuncionesPersona.js';
import * as DTOs from '../DTOs/FormacionDTOs.js';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import styles from './PopupSustitucion.module.css';

const PopupSustitucion = (props) => {
  const tipoSustitucion = props.tipoSustitucion;
  const participante = props.participante;
  const formacion = props.formacion;
  const goles = props.goles;
  const visible = props.visible;
  const mostrarEliminar = props.mostrarEliminar;
  const error = props.error;
  const isGrabandoProperty = props.isGrabando;
  let sustitucionActual = props.sustitucionActual;
  if (!sustitucionActual) {
    sustitucionActual = props.participante
      ? DTOs.SustitucionParticipante(props.participante, props.tipoSustitucion)
      : DTOs.SustitucionVacia();
  }
  const [datosSustitucion, setDatosSustitucion] = useState(sustitucionActual);
  const [motivosSustitucion, setMotivosSustitucion] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  // Lista de participantes que pueden salir (tienen persona o personaSinId)
  const participantesSale = formacion.filter(
    (x) =>
      (x.persona || x.personaSinId) &&
      (x.titularidad === Titularidad.TITULAR ||
        (x.titularidad === Titularidad.SUPLENTE && x.idSustitucionEntra)) &&
      !x.idSustitucionSale
  );

  // Lista de participantes que pueden entrar (tienen persona o personaSinId)
  const participantesEntra = formacion.filter(
    (x) =>
      (x.persona || x.personaSinId) &&
      x.titularidad === Titularidad.SUPLENTE &&
      !x.idSustitucionEntra
  );

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    fetchData(
      'parametros/tipos_motivo?tipoObjeto=' + TipoObjeto.SUSTITUCION,
      setMotivosSustitucion
    );
  }, [fetchData]);

  const vaciarForm = () => {
    setDatosSustitucion(DTOs.SustitucionVacia(participante, tipoSustitucion));
  };

  const onAceptar = (tiempo, minutos) => {
    if (
      datosSustitucion.participanteSale &&
      (datosSustitucion.participanteEntra || datosSustitucion.sinIngreso) &&
      datosSustitucion.motivo
    ) {
      const sustitucion = {
        ...datosSustitucion,
        // Asegurar que idFormacion y jugador estén sincronizados
        idFormacionSale: datosSustitucion.participanteSale.idPartidoFormacion,
        jugadorSale: datosSustitucion.participanteSale.persona,
        idFormacionEntra: datosSustitucion.participanteEntra
          ? datosSustitucion.participanteEntra.idPartidoFormacion
          : null,
        jugadorEntra: datosSustitucion.participanteEntra
          ? datosSustitucion.participanteEntra.persona
          : null,
        tiempo: tiempo,
        minutos: minutos,
      };
      const errorValidacion = Funciones.ValidarMinutosSustitucion(sustitucion, goles);
      if (errorValidacion) {
        alert(errorValidacion);
      } else {
        props.onSustitucionAceptada(sustitucion);
        vaciarForm();
      }
    } else {
      alert('Debe cargar todos los datos del cambio');
    }
  };

  const onCancelar = () => {
    props.onCancelar();
    vaciarForm();
  };

  const onEliminar = () => {
    props.onSustitucionEliminada(datosSustitucion);
    vaciarForm();
  };

  const onMotivoSustitucionChange = (event) => {
    const motivoElegido = encontrarCodigoString(motivosSustitucion, event.target.value);
    setDatosSustitucion({
      ...datosSustitucion,
      motivo: motivoElegido,
    });
  };

  const onPersonaEntraElegida = (participante) => {
    setDatosSustitucion({
      ...datosSustitucion,
      participanteEntra: participante,
      idFormacionEntra: participante.idPartidoFormacion,
      jugadorEntra: participante.persona,
    });
  };

  const onPersonaSaleElegida = (participante) => {
    setDatosSustitucion({
      ...datosSustitucion,
      participanteSale: participante,
      idFormacionSale: participante.idPartidoFormacion,
      jugadorSale: participante.persona,
    });
  };

  return (
    <PopupTiempo
      visible={visible}
      texto={participante && participante.persona ? 'Cambio en ' + participante.equipo.nombre : ''}
      tiempo={datosSustitucion.tiempo}
      minutos={datosSustitucion.minutos}
      height="13rem"
      width="25rem"
      mostrarEliminar={mostrarEliminar}
      error={erroresGetLista || error}
      isCargando={isCargando}
      isGrabando={isGrabandoProperty}
      onAceptar={onAceptar}
      onCancelar={onCancelar}
      onEliminar={onEliminar}
    >
      {visible && (
        <div className={`${styles.datosCambio}`}>
          <div className={`${styles.detalle}`}>
            <div>Sale:</div>
            <ComboSelectorParticipante
              lista={participantesSale}
              valorActual={
                datosSustitucion.participanteSale
                  ? FuncionesPersona.TextoParticipante(datosSustitucion.participanteSale)
                  : ''
              }
              onItemElegido={onPersonaSaleElegida}
              disabled={isGrabandoProperty}
            />
          </div>
          <div className={`${styles.detalle}`}>
            <div>Entra:</div>
            <ComboSelectorParticipante
              lista={participantesEntra}
              valorActual={
                datosSustitucion.participanteEntra
                  ? FuncionesPersona.TextoParticipante(datosSustitucion.participanteEntra)
                  : ''
              }
              onItemElegido={onPersonaEntraElegida}
              disabled={isGrabandoProperty}
            />
          </div>
          <div className={`${styles.detalle}`}>
            <div>Motivo sustitución:</div>
            <select
              value={datosSustitucion.motivo ? datosSustitucion.motivo.codigo : ''}
              onChange={onMotivoSustitucionChange}
              disabled={isGrabandoProperty}
            >
              {motivosSustitucion &&
                motivosSustitucion.map((motivo) => (
                  <option key={motivo.codigo} value={motivo.codigo}>
                    {motivo.descripcion}
                  </option>
                ))}
            </select>
          </div>
        </div>
      )}
    </PopupTiempo>
  );
};

export default PopupSustitucion;
